// Copyright: IQGeo Limited 2010-2019
import myw from 'myWorld-base';
import L from 'leaflet';

/* Implementation for markers. The trick here of reinserting the element to the front of the parents 
    children is consistent of the Leaflet implementation for Paths. One application of this is to ensure 
    vector layer markers do not get click events that are meant for highlight circles after a vector layer 
    redraw (and restores the DOM to how it looked before the redraw)
*/
L.Marker.prototype.bringToBack = function() {
    const parent = this._icon.parentElement,
        first = parent.firstChild;
    parent.insertBefore(this._icon, first);
};

// From http://gregorthemapguy.blogspot.co.uk/2014/02/leaflet-latlng-objects-get-bearings.html
L.LatLng.prototype.bearingTo = function(other) {
    const d2r = Math.PI / 180;
    const r2d = 180 / Math.PI;
    const lat1 = this.lat * d2r;
    const lat2 = other.lat * d2r;
    const dLon = (other.lng - this.lng) * d2r;
    const y = Math.sin(dLon) * Math.cos(lat2);
    const x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(dLon);
    let brng = Math.atan2(y, x);

    brng = brng * r2d;
    brng = (brng + 360) % 360;
    return brng;
};

//  As of iOS14, the check leaflet uses to add tap handlers is faulty. Perform the correct check here and add it if the last check didn't pass
const originalTapCheckPassed = (L.Browser.touch && !L.Browser.pointer);
if (!originalTapCheckPassed) {
    //  Use this check to account for being in the iOS native app
    const appleWebKit = navigator.userAgent.indexOf('AppleWebKit') >= 0;
    const isNativeSafari = appleWebKit && myw.isNativeApp;
    if (L.Browser.touch && (!L.Browser.pointer || L.Browser.safari || appleWebKit)) {
        L.Map.addInitHook('addHandler', 'tap', L.Map.Tap);
    }
}